import React from 'react';
import { Shield } from 'lucide-react';
import { siteContent } from '../data/mock';

const GuaranteeSection = () => {
  const { guarantee } = siteContent;

  return (
    <section className="guarantee-section section-padding" data-testid="guarantee-section">
      <div className="container">
        <div className="content-card guarantee-card">
          <div className="guarantee-icon">
            <Shield size={48} strokeWidth={1.5} />
          </div>
          <h2 className="guarantee-title" data-testid="guarantee-title">{guarantee.title}</h2>
          <p className="guarantee-description">{guarantee.description}</p>
          <p className="guarantee-emphasis">{guarantee.emphasis}</p>
          <p className="guarantee-pastoral-note">{guarantee.pastoralNote}</p>
        </div>
      </div>
    </section>
  );
};

export default GuaranteeSection;
